export default __webpack_public_path__ + "static/media/imageTum15.36d5eb2a.jpg";